export default "__VITE_ASSET__DTkhHZLw__"